module.exports = __webpack_public_path__ + "img/9_76.dcbfac08.png";